import script from "./WhatsAppEnableDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhatsAppEnableDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./WhatsAppEnableDrawer.vue?vue&type=style&index=0&id=16b078e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16b078e2"]])

export default __exports__